"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSVG2CSS = getSVG2CSS;
function getSVG2CSS(_ref) {
  var input = _ref.input;
  console.log("svg:", input);
  var encoded = encodeURIComponent(input).replace(/'/g, "%27").replace(/"/g, "%22");
  if (!encoded.includes("xmlns")) {
    encoded = encoded.replace("svg", "svg xmlns='http://www.w3.org/2000/svg'");
  }
  var dataURI = 'url("data:image/svg+xml;utf8,' + encoded + '")';
  return dataURI;
}